import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { DoughnutLayout } from './DoughnutLayout';

import SkeletonImage from 'assets/images/donutchartskeleton.svg';

const DoughnutPlaceholderChartCircle = styled('div', { name: 'DoughnutPlaceholderChartCircle' })(
  () => ({
    position: 'relative',
    height: '100%',
    aspectRatio: '1/1',
    borderRadius: '50%',
    overflow: 'hidden',
    margin: '0 auto',
  }),
);

const DoughnutPlaceholderText = styled('div', { name: 'DoughnutPlaceholderText' })({
  textAlign: 'center',
});

type DoughnutPlaceholderCardProps = {
  placeholder: string;
};

export const DoughnutPlaceholderCard = ({ placeholder }: DoughnutPlaceholderCardProps) => {
  return (
    <DoughnutLayout
      chart={
        <DoughnutPlaceholderChartCircle>
          <SkeletonImage />
        </DoughnutPlaceholderChartCircle>
      }
      legend={
        <DoughnutPlaceholderText>
          <Typography variant="text1" color="text.secondary">
            {placeholder}
          </Typography>
        </DoughnutPlaceholderText>
      }
    />
  );
};
